var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      attrs: { href: "#" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.openModal($event)
        },
      },
    },
    [_vm._v("contact us")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }